<template>
<div class="p4-report">
  <VTextField

    v-if="show"
    v-model="inputVal"
    dense
    class="no-print"
    placeholder="Type keyword..."
    v-bind="$props"
    autocomplete="off"
    prepend-icon="search"
  />
</div>
</template>

<script>
export default {
    name: "PsSearchBox",
    props: {
        solo: {
            type: Boolean, 
            required: false
        },
        dense: {
            type: Boolean,
            required: false
        },
        id: {
            type: String,
            required: true
        },
        appendIcon: {
            type: String,
            default: ""
        },
        height: {
            type: String,
            default: ""
        },
        backgroundColor: {
            type: String,
            default: "#003F64"
        },
        color: {
            type: String,
            default: "#003F64"
        },
        prependIcon: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            required: false,
            default: ""
        },
        value: {
            type: String,
            required: false,
            default: ""
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        outline: {
            type: Boolean,
            required: false,
            default: false
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessages: {
            type: String,
            required: false,
            default: ""
        }
    },
    data: () => ({
        inputVal: "",
        show: true
    
    }),
    watch: {
        inputVal(val) {
            this.$emit("input", val);
        }
    },
    mounted() {
        window.Bus.$on("clickedSearch", d => {
            openSearch();
        });
        window.Bus.$on("clearSearch", d => {
            this.clearSearch();
        });
    },
    methods: {
        clearSearch() {
            this.inputVal = "";
        },
        openSearch() {
            this.show = true;
        }
    }
};
</script>
<style>
input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px white inset;
  -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-border-radius: 10em;
  -moz-border-radius: 10em;
  border-radius: 10em;
  -webkit-transition: all 1.5s;
  -moz-transition: all 1.5s;
  transition: all 1.5s;
} 
</style>
